import es from '@/idioma/es.js'
import en from '@/idioma/en.js'
export default {
  es: es,
  en: en,
  aIdiomas: [
    {
      value: 'es',
      text: 'Español'
    },
    {
      value: 'en',
      text: 'English'
    }
  ]
}
